import $ from 'jquery'
import constants from "../lib/constants";

export default class {
  constructor(element) {
    if (!element) {
      return false;
    }

    this.wrap = jQuery(element);
    this.sliderFor = this.wrap.find('.slider-for')
    this.sliderNav = this.wrap.find('.slider-nav')
    this.arrows = this.wrap.find('.s-photo-text-slider__arrows')

    this._iniSlider()
    console.log('this.wrap', this.wrap)
  }

  _iniSlider() {
    this.sliderFor.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav'
    });
    this.sliderNav.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      fade: true,
      appendArrows:  this.arrows,
      focusOnSelect: true
    });
  }
}
